 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth-lock":"auth-lock","auth-lock2":"auth-lock2","auth-reminder":"auth-reminder","auth-reminder2":"auth-reminder2","auth-signin":"auth-signin","auth-signup":"auth-signup","auth-signup2":"auth-signup2","forms-plugins":"forms-plugins","elements-timeline":"elements-timeline","plugins-gallery":"plugins-gallery","forms-editors":"forms-editors","forms-validation":"forms-validation","pages-boxed-dashboard~pages-dashboard~plugins-charts":"pages-boxed-dashboard~pages-dashboard~plugins-charts","pages-boxed-dashboard":"pages-boxed-dashboard","pages-dashboard":"pages-dashboard","plugins-charts":"plugins-charts","plugins-calendar":"plugins-calendar","plugins-dialogs":"plugins-dialogs","plugins-image-cropper":"plugins-image-cropper","plugins-rating":"plugins-rating","plugins-syntax-highlighting":"plugins-syntax-highlighting","various-coming-soon":"various-coming-soon"}[chunkId]||chunkId) + "." + {"auth-lock":"889ff26a","auth-lock2":"4629abd6","auth-reminder":"39bfb283","auth-reminder2":"afa39710","auth-signin":"2803e6c7","auth-signup":"ebd8d0d1","auth-signup2":"d8c436bf","chunk-025f9913":"b9f8cb9a","chunk-09d809be":"ba605e16","chunk-0a75e8e6":"b3e93e4c","chunk-0de826e8":"96262c94","chunk-0f8cfaf6":"3f059667","chunk-1731b5d3":"70bb6761","chunk-4a2df7cc":"8c0b40d4","chunk-66de054d":"503eb04e","chunk-995ad572":"b10b2a0e","forms-plugins":"366ad039","chunk-0bc976ba":"bb47eee5","chunk-055e5b78":"addd69a0","chunk-22dbf468":"f16b3188","chunk-5510b5e6":"83acdf6e","elements-timeline":"5c390a86","plugins-gallery":"af9d732a","chunk-1db66836":"7edd0ec2","chunk-256281b0":"4f21aff2","chunk-2d0a3548":"5f93eb01","chunk-2d0a4bfb":"4d8393dc","chunk-2d0a4fae":"d8b28f9d","chunk-2d0abe3e":"930aefe4","chunk-2d0ac1c9":"da8605f4","chunk-2d0aef26":"91a2d982","chunk-2d0af432":"b9c72548","chunk-2d0b27b6":"3a30dd8c","chunk-2d0b3042":"6a7b3864","chunk-2d0b365b":"a4d1404b","chunk-2d0b92ae":"583c96fd","chunk-2d0b9435":"25587ef7","chunk-2d0b9833":"f224a502","chunk-2d0b9c11":"bff38d58","chunk-2d0ba187":"fc7696b7","chunk-2d0ba6cf":"f8303733","chunk-2d0ba948":"d1b5872c","chunk-2d0baafb":"95844e08","chunk-2d0bd908":"f8706b8d","chunk-2d0bdbc6":"fe912264","chunk-2d0bdd2b":"1af9fc6d","chunk-2d0be0fa":"8142cf63","chunk-2d0c0a08":"764fc5b5","chunk-2d0c0a58":"2af863d9","chunk-2d0c1574":"f47a8b8c","chunk-2d0c209d":"f74da8f3","chunk-2d0c4303":"442d0cb2","chunk-2d0c4c39":"0ded964a","chunk-2d0c55f2":"9a5da171","chunk-2d0c8be5":"2765ecb9","chunk-2d0c94e1":"65b1b224","chunk-2d0cc654":"02067bb5","chunk-2d0ccf74":"b99a83b9","chunk-2d0cf696":"9c23154d","chunk-2d0d0207":"57caacb3","chunk-2d0d05f9":"88c6d0e6","chunk-2d0d3304":"403fd009","chunk-2d0d39f9":"b9934272","chunk-2d0d6b75":"67739779","chunk-2d0d6f4c":"f8a4d8ee","chunk-2d0da726":"bee0f889","chunk-2d0da7f0":"4414e913","chunk-2d0dd4fc":"c0173720","chunk-2d0deeef":"e4979fe4","chunk-2d0e2c59":"7cf4d2bd","chunk-2d0e9b18":"ff60ac4a","chunk-2d0ea103":"5db6c695","chunk-2d0f00ec":"fcb65bf8","chunk-2d0f0f03":"989c40a4","chunk-2d0f0fc0":"75b60d02","chunk-2d20742f":"09a30802","chunk-2d208497":"29c39b8c","chunk-2d208c37":"2c1e3277","chunk-2d209029":"6bafaff0","chunk-2d209b6e":"364418c9","chunk-2d20f6ca":"5af56d5b","chunk-2d213399":"c6acf93d","chunk-2d21770a":"fea77f39","chunk-2d217c76":"8e9a30b6","chunk-2d219ff1":"1d5e52ec","chunk-2d21a7d6":"736f6c47","chunk-2d21a844":"5d48c587","chunk-2d21aac0":"ddf00c31","chunk-2d21b8c7":"5e2b343c","chunk-2d221830":"34741cc1","chunk-2d221875":"9c66dc3c","chunk-2d22275c":"6bec1130","chunk-2d2227b6":"856fff7b","chunk-2d224c83":"09d9b3ee","chunk-2d225681":"2f890c3f","chunk-2d229029":"207df890","chunk-2d229481":"b8102b32","chunk-2d22d7d6":"16c45b42","chunk-2d22e116":"3a33142f","chunk-2d238035":"c576251e","chunk-38df2058":"61150b09","chunk-3a746afe":"628eeff9","chunk-41319c16":"3f3a5c39","chunk-48dcae00":"2bae0e4c","chunk-6e79948e":"603b62c9","chunk-744afdfe":"a6a58e62","chunk-7de3045d":"4d3e106c","chunk-a2f659da":"8ce3b208","chunk-c2f13a36":"8ad2e32f","forms-editors":"1541722a","forms-validation":"463c938a","pages-boxed-dashboard~pages-dashboard~plugins-charts":"05aaca66","pages-boxed-dashboard":"c2083667","pages-dashboard":"5b62e9cc","plugins-charts":"2ba707a6","plugins-calendar":"f59f2b0b","plugins-dialogs":"1bd85f22","plugins-image-cropper":"f3b353eb","plugins-rating":"c784c766","plugins-syntax-highlighting":"66284001","various-coming-soon":"783871ed"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-09d809be":1,"chunk-0a75e8e6":1,"chunk-0de826e8":1,"chunk-0f8cfaf6":1,"chunk-1731b5d3":1,"chunk-4a2df7cc":1,"chunk-66de054d":1,"chunk-995ad572":1,"forms-plugins":1,"chunk-0bc976ba":1,"chunk-41319c16":1,"chunk-6e79948e":1,"chunk-c2f13a36":1,"forms-editors":1,"plugins-charts":1,"plugins-calendar":1,"plugins-dialogs":1,"plugins-image-cropper":1,"plugins-syntax-highlighting":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth-lock":"auth-lock","auth-lock2":"auth-lock2","auth-reminder":"auth-reminder","auth-reminder2":"auth-reminder2","auth-signin":"auth-signin","auth-signup":"auth-signup","auth-signup2":"auth-signup2","forms-plugins":"forms-plugins","elements-timeline":"elements-timeline","plugins-gallery":"plugins-gallery","forms-editors":"forms-editors","forms-validation":"forms-validation","pages-boxed-dashboard~pages-dashboard~plugins-charts":"pages-boxed-dashboard~pages-dashboard~plugins-charts","pages-boxed-dashboard":"pages-boxed-dashboard","pages-dashboard":"pages-dashboard","plugins-charts":"plugins-charts","plugins-calendar":"plugins-calendar","plugins-dialogs":"plugins-dialogs","plugins-image-cropper":"plugins-image-cropper","plugins-rating":"plugins-rating","plugins-syntax-highlighting":"plugins-syntax-highlighting","various-coming-soon":"various-coming-soon"}[chunkId]||chunkId) + "." + {"auth-lock":"31d6cfe0","auth-lock2":"31d6cfe0","auth-reminder":"31d6cfe0","auth-reminder2":"31d6cfe0","auth-signin":"31d6cfe0","auth-signup":"31d6cfe0","auth-signup2":"31d6cfe0","chunk-025f9913":"31d6cfe0","chunk-09d809be":"67a180fb","chunk-0a75e8e6":"478117c1","chunk-0de826e8":"478117c1","chunk-0f8cfaf6":"478117c1","chunk-1731b5d3":"478117c1","chunk-4a2df7cc":"478117c1","chunk-66de054d":"478117c1","chunk-995ad572":"478117c1","forms-plugins":"197d6b92","chunk-0bc976ba":"c40dc656","chunk-055e5b78":"31d6cfe0","chunk-22dbf468":"31d6cfe0","chunk-5510b5e6":"31d6cfe0","elements-timeline":"31d6cfe0","plugins-gallery":"31d6cfe0","chunk-1db66836":"31d6cfe0","chunk-256281b0":"31d6cfe0","chunk-2d0a3548":"31d6cfe0","chunk-2d0a4bfb":"31d6cfe0","chunk-2d0a4fae":"31d6cfe0","chunk-2d0abe3e":"31d6cfe0","chunk-2d0ac1c9":"31d6cfe0","chunk-2d0aef26":"31d6cfe0","chunk-2d0af432":"31d6cfe0","chunk-2d0b27b6":"31d6cfe0","chunk-2d0b3042":"31d6cfe0","chunk-2d0b365b":"31d6cfe0","chunk-2d0b92ae":"31d6cfe0","chunk-2d0b9435":"31d6cfe0","chunk-2d0b9833":"31d6cfe0","chunk-2d0b9c11":"31d6cfe0","chunk-2d0ba187":"31d6cfe0","chunk-2d0ba6cf":"31d6cfe0","chunk-2d0ba948":"31d6cfe0","chunk-2d0baafb":"31d6cfe0","chunk-2d0bd908":"31d6cfe0","chunk-2d0bdbc6":"31d6cfe0","chunk-2d0bdd2b":"31d6cfe0","chunk-2d0be0fa":"31d6cfe0","chunk-2d0c0a08":"31d6cfe0","chunk-2d0c0a58":"31d6cfe0","chunk-2d0c1574":"31d6cfe0","chunk-2d0c209d":"31d6cfe0","chunk-2d0c4303":"31d6cfe0","chunk-2d0c4c39":"31d6cfe0","chunk-2d0c55f2":"31d6cfe0","chunk-2d0c8be5":"31d6cfe0","chunk-2d0c94e1":"31d6cfe0","chunk-2d0cc654":"31d6cfe0","chunk-2d0ccf74":"31d6cfe0","chunk-2d0cf696":"31d6cfe0","chunk-2d0d0207":"31d6cfe0","chunk-2d0d05f9":"31d6cfe0","chunk-2d0d3304":"31d6cfe0","chunk-2d0d39f9":"31d6cfe0","chunk-2d0d6b75":"31d6cfe0","chunk-2d0d6f4c":"31d6cfe0","chunk-2d0da726":"31d6cfe0","chunk-2d0da7f0":"31d6cfe0","chunk-2d0dd4fc":"31d6cfe0","chunk-2d0deeef":"31d6cfe0","chunk-2d0e2c59":"31d6cfe0","chunk-2d0e9b18":"31d6cfe0","chunk-2d0ea103":"31d6cfe0","chunk-2d0f00ec":"31d6cfe0","chunk-2d0f0f03":"31d6cfe0","chunk-2d0f0fc0":"31d6cfe0","chunk-2d20742f":"31d6cfe0","chunk-2d208497":"31d6cfe0","chunk-2d208c37":"31d6cfe0","chunk-2d209029":"31d6cfe0","chunk-2d209b6e":"31d6cfe0","chunk-2d20f6ca":"31d6cfe0","chunk-2d213399":"31d6cfe0","chunk-2d21770a":"31d6cfe0","chunk-2d217c76":"31d6cfe0","chunk-2d219ff1":"31d6cfe0","chunk-2d21a7d6":"31d6cfe0","chunk-2d21a844":"31d6cfe0","chunk-2d21aac0":"31d6cfe0","chunk-2d21b8c7":"31d6cfe0","chunk-2d221830":"31d6cfe0","chunk-2d221875":"31d6cfe0","chunk-2d22275c":"31d6cfe0","chunk-2d2227b6":"31d6cfe0","chunk-2d224c83":"31d6cfe0","chunk-2d225681":"31d6cfe0","chunk-2d229029":"31d6cfe0","chunk-2d229481":"31d6cfe0","chunk-2d22d7d6":"31d6cfe0","chunk-2d22e116":"31d6cfe0","chunk-2d238035":"31d6cfe0","chunk-38df2058":"31d6cfe0","chunk-3a746afe":"31d6cfe0","chunk-41319c16":"bd64e1db","chunk-48dcae00":"31d6cfe0","chunk-6e79948e":"1e879015","chunk-744afdfe":"31d6cfe0","chunk-7de3045d":"31d6cfe0","chunk-a2f659da":"31d6cfe0","chunk-c2f13a36":"1e879015","forms-editors":"2cdb4939","forms-validation":"31d6cfe0","pages-boxed-dashboard~pages-dashboard~plugins-charts":"31d6cfe0","pages-boxed-dashboard":"31d6cfe0","pages-dashboard":"31d6cfe0","plugins-charts":"04f72176","plugins-calendar":"345b4ec0","plugins-dialogs":"1ac00c14","plugins-image-cropper":"f9c8b18b","plugins-rating":"31d6cfe0","plugins-syntax-highlighting":"be4122a3","various-coming-soon":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["pages-boxed-dashboard~pages-dashboard~plugins-charts","pages-dashboard"]]);
 	return startupResult;
